import React from "react";
import * as actions from './Actions';
import Service from '../../service/Service';
import ShareOptions from '../../discussions/common/ShareOptions';
const service = new Service();

export default function CommonSection ({discuData, eleRef}){
    // console.log("discuData === ", discuData);
    // var eleRef = discuData.eleRef;
    // var discuData = discuData.discuData;
    return(
        <section className="disc-section">
            <div className="section-title">DISCUSSIONS</div>
            <div className="queBlock">
            {discuData.discussion && discuData.discussion.map((data, index)=>
                <div key={index} className="common-sect">
                    <div className="left arti-image">
                        <a href={`/discussions/t/${service.genquestionurl(data.title)}-${data.discussionId}`}>
                        {data.urls && data.urls.length > 0 &&
                            <img src={data.urls[0].source.replace("http://", "https://").replace("jpg", "webp")} onError={(e) => e.target.src = data.urls[0].source.replace("http://", "https://")} id="dev_dis_img"/>
                        }
                        </a>
                    </div>
                    <div className="left arti-details">
                        <div className="M15_42 common-title line-clamp dev_dis_title">
                            <a className="M15_42" href={`/discussions/t/${service.genquestionurl(data.title)}-${data.discussionId}`}>
                            {data.title}
                            </a>
                        </div>
                        <div className="R14_75 common-desc">
                            <span className="line-clamp">{data.discussionsDiscription}</span>
                            {/* <span className="R12_9e" id="dev_dis_dtl">Read More</span> */}
                        </div>
                        <div className="arti-actions">
                            <div className="left view-action">
                                <a href={`/discussions/t/${service.genquestionurl(data.title)}-${data.discussionId}/`}>
                                    <span data-icon-font="e" className="left comment-icon"></span>
                                </a>
                                <span className="action-text left">{data.commentCount}</span>
                            </div>
                            <div className="left view-action like-act">
                                <span data-icon-font="$" className="left"></span>
                                <span className="action-text left">{data.viewCount} Views</span>
                            </div>
                            
                            <div className="share-action" id={`share_${data.discussionId}`} onClick={() => actions.shareOn(`${data.discussionId}`)}>
                                <span className="share-ic share-click">
                                    <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/facebook-icon.png" alt="Facebook" title="Facebook" />
                                </span>
                                <span className="share-ic whtap-icon share-click" data-icon-font="&#xe019;"></span>
                                <span className="action-text right share-click">Share</span>
                                <ShareOptions discussion={data} eleRef={this} />
                            </div>
                        </div>
                    </div>
                </div>
                )}
            </div>
            {discuData.search_cnt > discuData.discussion.length &&
            <div className="moreResults dev_v_all" title="DISCUSSIONS" onClick={()=>eleRef.getMoreSearchData(discuData.type)} >SEE MORE RESULTS</div>
            }
        </section>
    );
}
